import {
  DROPDOWN_ITEM_LABELS,
  DropdownItem,
  PermissionsDropdownState,
  SUBDOMAIN_DROPDOWN_ITEM_LABELS,
  SubdomainDropdownItem
} from './shared.types'
import {
  DropdownItem as DropdownItemComponent,
  DropdownItemText
} from '../../Dropdown/Dropdown.components'
import { Icon } from '@dtx-company/shared-components/src'
import { ListItemIcon, MenuItemProps } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import React, { useEffect, useRef } from 'react'

export const DropdownMenuItem: React.FC<DropdownMenuItemProps> = props => {
  const state = useDropdownMenuItemState(props)
  return (
    <DropdownItemComponent {...getDropdownItemProps(state)}>
      <ListItemIcon>
        <Icon
          src={
            state.subdomainItem
              ? SUBDOMAIN_DROPDOWN_ITEM_ICONS[state.subdomainItem]
              : DROPDOWN_ITEM_ICONS[state.item]
          }
        />
      </ListItemIcon>
      <DropdownItemText>
        {state.subdomainItem
          ? SUBDOMAIN_DROPDOWN_ITEM_LABELS[state.subdomainItem]
          : DROPDOWN_ITEM_LABELS[state.item]}
      </DropdownItemText>
      <ListItemIcon>{state.selected ? <SelectedIcon /> : null}</ListItemIcon>
    </DropdownItemComponent>
  )
}

const SelectedIcon: React.FC = () => <CheckIcon color="primary" fontSize="small" />

function useDropdownMenuItemState(props: DropdownMenuItemProps): DropdownMenuItemState {
  const { dropdownState, item, subdomainItem } = props
  const selected = subdomainItem
    ? subdomainItem === dropdownState.whiteLabelItemSelected
    : item === dropdownState.itemSelected
  const itemRef = useRef<HTMLLIElement | null>(null)
  useEffect(() => {
    if (selected && itemRef.current) {
      itemRef.current.focus()
    }
  }, [selected, itemRef])

  return {
    item,
    selected: item === dropdownState.itemSelected,
    onClick: () => dropdownState.onNewItemSelected(subdomainItem ?? item),
    itemRef,
    isRemovePermissionItem:
      item === DropdownItem.REMOVE || subdomainItem === SubdomainDropdownItem.REMOVE,
    subdomainItem
  }
}

function getDropdownItemProps(state: DropdownMenuItemState): MenuItemProps {
  return {
    sx: {
      color: state.isRemovePermissionItem ? 'red' : 'black'
    },
    selected: state.selected,
    onClick: state.onClick,
    key: state.item,
    value: state.item,
    ref: state.itemRef
  }
}

interface DropdownMenuItemProps {
  dropdownState: PermissionsDropdownState
  item: DropdownItem
  subdomainItem?: SubdomainDropdownItem
}

interface DropdownMenuItemState {
  item: DropdownItem
  subdomainItem?: SubdomainDropdownItem
  selected: boolean
  isRemovePermissionItem: boolean
  onClick: () => void
  itemRef: React.MutableRefObject<HTMLLIElement | null>
}

const DROPDOWN_ITEM_ICONS: Record<string, string> = {
  [DropdownItem.CREATOR]: '/icons/profile.svg',
  [DropdownItem.EDITOR]: '/icons/pencil-outline.svg',
  [DropdownItem.VIEWER]: '/icons/eye.svg',
  [DropdownItem.REMOVE]: '/icons/close.svg'
}

const SUBDOMAIN_DROPDOWN_ITEM_ICONS: Record<string, string> = {
  [SubdomainDropdownItem.SHARED]: '/icons/eye.svg',
  [SubdomainDropdownItem.REMOVE]: '/icons/close.svg'
}
